import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SimulatorPage.css';
import GameCanvas from '../components/simulator/GameCanvas';
import NavigationButtons from '../components/NavigationButtons';
import poko from '../assets/poko_game.png';
import map from '../components/simulator/img/SignMatesTown.png';
import { stopBackgroundMusic } from '../components/simulator/startGame';

function SimulatorPage() {
	const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
	const [firstVisit, setFirstVisit] = useState(true);
	const [showInstructions, setShowInstructions] = useState(false);
	const [showGame, setShowGame] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsSmallScreen(window.innerWidth < 768);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
			stopBackgroundMusic();
		};
	}, []);

	const handleStartGame = () => {
		setShowGame(true);
		if (firstVisit) {
			setShowInstructions(true); // open modal
			setFirstVisit(false);
		}
	};

	// Modal that shows instructions for how to play the game (shown only on first visit or when triggered)
	const InstructionModal = () => {
		if (!showInstructions) return null;

		const justClose = () => {
			setShowInstructions(false);
		};

		return (
			<div className="instructions-modal-overlay simulator-page" onClick={justClose}>
				<div className="instructions-modal" onClick={(e) => e.stopPropagation()}>
					{!firstVisit && (
						<button className="close-button" onClick={justClose}>×</button>
					)}
					<h2>🧠 How to Play?</h2>
					<div className="instruction-section">
						<p>• Use the arrow keys or W/A/S/D to move around</p>
						<p>• Talk to characters to keep the adventure going!</p>
					</div>
					<div className="instruction-section">
						<h3>Map:</h3>
						<img className='game-map' src={map} alt='simulator map'/>
					</div>

					{firstVisit ? (
						<button className="game-btn" onClick={justClose}>
							Got it, let's go!
						</button>
					) : (
						<button className="game-btn" onClick={justClose}>
							Close
						</button>
					)}
				</div>
			</div>
		);
	};

	if (isSmallScreen) {
		return (
			<div className="simulator-page page">
				<div className="white-wrapper container">
					<div className="page-title">
						<h1>🧠 Simulator</h1>
						<h5>Let's play on a bigger screen!</h5>
					</div>
					<div className="speech-section">
						<div className="speech-bubble-left">
							<strong>Oops! 👀</strong>
							<p>This adventure needs more space to play.</p>
							<p>Please try again on a computer or tablet with a bigger screen!</p>
							<p>We'll be ready when you are! 💻🎉</p>
						</div>
						<img src={poko} alt="Buddy" className="poko" />
					</div>
				</div>
				<NavigationButtons />
			</div>
		);
	}

	return (
		<div className="simulator-page page">
			<div className="white-wrapper container">
				<div className="page-title">
					<h1>🎮 Simulator</h1>
					<h5>Step into their world and learn by doing!</h5>
				</div>

				{!showGame ? (
					<div className="speech-section">
						<div className="speech-bubble-left">
							<strong>🎮 Welcome to the Deaf Life Simulator!</strong>
							<p>👟 Step into the world of a deaf student — and learn with every move!</p>
							<p>In this adventure, you'll explore the world just like a deaf student.</p>
							<p>🔍 Discover how it feels to miss sounds,</p>
							<p>🧰 Collect helpful tools, and</p>
							<p>🗣️ Learn how to communicate in new ways.</p>
							<p>Ready to start your journey?</p>
							<button onClick={handleStartGame}>
								Start!
							</button>
						</div>
						<img src={poko} alt="Buddy" className="poko" />
					</div>
				) : (
					<>
						<button className="help-button" onClick={() => setShowInstructions(true)}>
							❔
						</button>
						<GameCanvas />
					</>
				)}

				<InstructionModal />
			</div>

			<NavigationButtons />
		</div>
	);
}

export default SimulatorPage;